module.exports = __webpack_public_path__ + "static/media/slider-mlb.ff845ded.jpg";